var map = {
	"./de": [
		"9612",
		"chunk-2d0e5af4"
	],
	"./de.vue": [
		"9612",
		"chunk-2d0e5af4"
	],
	"./en": [
		"df22",
		"chunk-2d229b38"
	],
	"./en.vue": [
		"df22",
		"chunk-2d229b38"
	],
	"./it": [
		"ec7c",
		"chunk-2d230520"
	],
	"./it.vue": [
		"ec7c",
		"chunk-2d230520"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "936d";
module.exports = webpackAsyncContext;